/**
 * Leaderboard score formula. Tunable. Higher is better.
 *   - +100 per wave cleared
 *   - +10 per remaining life (encourages clean runs)
 *   - -50 per leaked HP
 *   - x1 / x1.5 / x3 by difficulty (Squire / Knight / Lord)
 *   - +5000 win bonus
 *
 * MUST stay in sync with expectedScore() in
 * supabase/functions/submit-run/logic.ts — src/systems/score.test.ts enforces
 * exact parity. Remaining lives are DERIVED from castleHp - leaks (not live
 * economy state) so castle heals cannot push the client score past the
 * server's recomputation, which only knows castleHp and the submitted leaks.
 */
export interface ScoreInput {
  victory: boolean;
  wavesCleared: number;
  castleHp: number;
  leaks: number;
  difficulty: number; // 1=Squire 2=Knight 3=Lord
}

export function computeScore(p: ScoreInput): number {
  const remainingLives = Math.max(0, p.castleHp - p.leaks);
  const base =
    p.wavesCleared * 100 +
    remainingLives * 10 -
    p.leaks * 50 +
    (p.victory ? 5000 : 0);
  const mult = p.difficulty === 3 ? 3 : p.difficulty === 2 ? 1.5 : 1;
  return Math.max(0, Math.round(base * mult));
}
